import React from 'react';
import cliniMACS1 from '../assets/img/cliniMACS-1.jpg';
import cliniMACS2 from '../assets/img/cliniMACS-2.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function PlateletRichPlasmaKits() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <p className="news-content">
                                    </p><div className="col-md-12">
                                        <div className="section-heading text-left">
                                            <h5>CliniMACS® System</h5>
                                        </div>
                                        <p className='mb-3'>
                                            The CliniMACS® System offers a flexible platform for processing and separation of virtually any cell type as well as customized processing protocols according to specific sample requirements. Unique reagents and tubing sets also allow for the transition of promising research applications into innovative cell therapy concepts. 
                                        </p>
                                        <p className='mb-3'>
                                            </p><ul>
                                                <li className='li-arrow'>Versatile platform for many cell separation protocols</li>
                                                <li className='li-arrow'>Functionally closed, sterile system</li>
                                                <li className='li-arrow'>Automated cell separation combining reproducibility with ease-of-use</li>
                                                <li className='li-arrow'>Broad range of CE-marked products</li>
                                                <li className='li-arrow'>Optimized software for cell depletion and enrichment</li>
                                            </ul>
                                        <p className='mb-3'></p>
                                        
                                        <p className='mb-3'>
                                            The CliniMACS® Plus Instrument is an automated cell separation system based on MACS® Technology. It enables the operator to perform clinical-scale magnetic enrichment of target cells or depletion of unwanted cells in a closed and sterile system. CliniMACS Technology offers reliability and convenience in one compact benchtop instrument. Customer-friendly software enables automatic collection of separated cells in different collection bags.
                                        </p>
                                <p className='mb-3'>
                                    <img src={cliniMACS1} className="alignright w-100"  alt="" />
                                </p>
                                        <p className='mb-3'>
                                            The newly developed CliniMACS Prodigy® integrates the MACS® Technology into a fully automated cell processing device that offers advanced solutions for streamlining cell processing workflows.
                                        </p><div className="divider my-2"></div>
                                <p className='mb-3'>
                                    <img src={cliniMACS2} className="alignright w-100"  alt="" />
                                </p>
                                    </div>

                                    <p className='mb-3'>
                                        The CliniMACS Prodigy® offers a unique all-in-one solution for cell processing in a closed GMP-compliant system. This next generation instrument is pivotal in propelling cell processing to the next level of automation.
                                    </p>
                                    <p className='mb-3'>
                                        The CliniMACS Prodigy offers a flexible platform for cell processing applications enabling the magnetic separation of different cell types as well as customized cell processing protocols.
                                    </p>
                                    <p className='mb-3'>
                                        The cell processing unit for fully automated washing, fractionation and cultivation of cells represents an integral component of the CliniMACS Prodigy. 
                                    </p>
                                    <div className="divider my-2"></div>
                                    <br /><br />
                                    <p className='mb-3'>
                                        </p><div className="section-heading text-left">
                                            <h5>Applications</h5>
                                        </div>
                                    <p className='mb-3'></p>
                                    <p className='mb-3'>
                                        
                                        The CliniMACS Prodigy has been developed as an integrated cell processing device in order to automate and standardize the complete manufacturing process of cellular products:
                                    </p>
                                    <ul>
                                            <li className='li-arrow'>Fractionation of starting material</li>
                                            <li className='li-arrow'>Cell washing</li>
                                            <li className='li-arrow'>Target cell labeling</li>
                                            <li className='li-arrow'>Magnetic cell separation</li>
                                            <li className='li-arrow'>Cell cultivation</li>
                                            <li className='li-arrow'>Volume reduction</li>
                                            <li className='li-arrow'>Final product formulation</li>
                                    </ul>
                                    <p className='mb-3'></p><p className='mb-3'></p>
                                    <div className="col-md-12" style={{textAlign:"center", borderTop:"1px solid", marginTop:"1%", paddingTop:"1%"}}>
                                    <a href="http://www.miltenyibiotec.com/en/" ><strong>Search for further information: www.miltenyibiotec.com</strong></a>
                                </div>
                            <p className='mb-3'></p>
                                </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default PlateletRichPlasmaKits;
